var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoWithdraw2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97345C0 7.42157 0 7.14563 0.0740273 6.89151C0.139601 6.66641 0.247366 6.4547 0.392027 6.26677C0.555337 6.05461 0.782021 5.8852 1.23539 5.54638L8.0177 0.477696C8.36902 0.215138 8.54468 0.0838583 8.73865 0.0333949C8.9098 -0.0111316 9.0902 -0.0111316 9.26135 0.0333949C9.45532 0.0838583 9.63098 0.215138 9.98231 0.477697L16.7646 5.54638C17.218 5.8852 17.4447 6.05461 17.608 6.26677C17.7526 6.4547 17.8604 6.66641 17.926 6.89151C18 7.14563 18 7.42157 18 7.97345V14.9252C18 16.0015 18 16.5396 17.782 16.9507C17.5903 17.3123 17.2843 17.6063 16.908 17.7905C16.4802 18 15.9201 18 14.8 18H3.2C2.0799 18 1.51984 18 1.09202 17.7905C0.715695 17.6063 0.409734 17.3123 0.217987 16.9507C0 16.5396 0 16.0015 0 14.9252V7.97345Z",
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_192443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9.5001H14V8.60006C14 8.03999 14 7.75995 13.891 7.54603C13.7951 7.35786 13.6422 7.20488 13.454 7.109C13.2401 7 12.9601 7 12.4 7H5.6C5.03995 7 4.75992 7 4.54601 7.109C4.35785 7.20487 4.20487 7.35786 4.10899 7.54603C4 7.75995 4 8.03999 4 8.60006V9.5001Z",
    fill: "#FFA6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5001H4M5.75 14.0003H5.6C5.03995 14.0003 4.75992 14.0003 4.54601 13.8913C4.35785 13.7954 4.20487 13.6424 4.10899 13.4542C4 13.2403 4 12.9603 4 12.4002V8.60006C4 8.03999 4 7.75995 4.10899 7.54603C4.20487 7.35786 4.35785 7.20487 4.54601 7.109C4.75992 7 5.03995 7 5.6 7H12.4C12.9601 7 13.2401 7 13.454 7.109C13.6422 7.20488 13.7951 7.35786 13.891 7.54603C14 7.75995 14 8.03999 14 8.60006V12.4002C14 12.9603 14 13.2403 13.891 13.4542C13.7951 13.6424 13.6422 13.7954 13.454 13.8913C13.2401 14.0003 12.9601 14.0003 12.4 14.0003H12.25",
    stroke: "url(#paint0_linear_415_192443)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.4999L9 15M9 15L7.5 13.4999M9 15V11.4999",
    stroke: "url(#paint1_linear_415_192443)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_192443",
    x: 2.5,
    y: 5.5,
    width: 15,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_192443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_192443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_192443",
    x1: 4,
    y1: 7,
    x2: 14.1676,
    y2: 7.25251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_192443",
    x1: 10.5,
    y1: 15,
    x2: 7.44852,
    y2: 14.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoWithdraw2);
export default __webpack_public_path__ + "static/media/OneoWithdraw2.dffea7379ac6b7d02afb44f577b002b0.svg";
export { ForwardRef as ReactComponent };